module.exports = __webpack_public_path__ + "img/xxnl-product3.f1d57786.png";